import React from 'react'
import type { SelectInlineInputProps } from '@ztechapps/webui.input'
import { Select, SelectInlineInput, buildEnumOptions } from '@ztechapps/webui.input'
import { UnitOfMeasureCategoryEnum } from '@ztechapps/common.contract'

export const categoryOptions = buildEnumOptions(UnitOfMeasureCategoryEnum)

export const UnitOfMeasureCategorySelect = ({ ...rest }) => {
  return (
    <Select
      {...{
        ...rest,
        options: categoryOptions,
      }}
    />
  )
}
export const UnitOfMeasureCategorySelectInlineInput = (props: SelectInlineInputProps) => {
  return <SelectInlineInput {...props} selectComponent={UnitOfMeasureCategorySelect} selectOptions={categoryOptions} />
}
